import { render, staticRenderFns } from "./RelatedFramesTable.vue?vue&type=template&id=35e73cba&"
import script from "./RelatedFramesTable.vue?vue&type=script&lang=js&"
export * from "./RelatedFramesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports